import { connect } from 'react-redux';
import { compose, withProps, withStateHandlers } from 'recompose';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'utils/types';
import dateFormatters from 'utils/dateAndTimes/formatters';

import { selectors as ordersSelectors } from 'state/orders';
import FilterDates from 'components/orders/Filters/Filters/Dates/component';

const getLabel = (firstPickupTime, lastDropoffTime, t) => {
  if (!isEmpty(firstPickupTime) && !isEmpty(lastDropoffTime))
    return t('label_dates_filter_both', {
      from: dateFormatters.getHumanReadableFormattedDate({
        value: firstPickupTime,
        t,
        format: 'short',
      }),
      to: dateFormatters.getHumanReadableFormattedDate({
        value: lastDropoffTime,
        t,
        format: 'short',
      }),
    });
  if (!isEmpty(firstPickupTime))
    return t('label_dates_filter_from', {
      date: dateFormatters.getHumanReadableFormattedDate({
        value: firstPickupTime,
        t,
        format: 'short',
      }),
    });
  if (!isEmpty(lastDropoffTime))
    return t('label_dates_filter_to', {
      date: dateFormatters.getHumanReadableFormattedDate({
        value: lastDropoffTime,
        t,
        format: 'short',
      }),
    });

  return t('empty_label_dates_filter');
};

const enhance = compose(
  withTranslation('Orders'),
  connect(
    (state) => ({
      firstPickupTime: ordersSelectors.getFilterFirstPickupTime(state),
      lastDropoffTime: ordersSelectors.getFilterLastDropoffTime(state),
      pathname: state.router.location.pathname,
    }),
    {}
  ),
  withStateHandlers(
    ({ filtersOpen }) => ({ filtersOpen }),

    {
      toggleMenuHandler:
        ({ filtersOpen }) =>
        (e) => {
          e.stopPropagation();
          e.preventDefault();
          return { filtersOpen: !filtersOpen };
        },
    }
  ),
  withProps(({ firstPickupTime, lastDropoffTime, t }) => ({
    dateLabel: getLabel(firstPickupTime, lastDropoffTime, t),
  }))
);

export default enhance(FilterDates);
